import { render, staticRenderFns } from "./ChatBotPersonalDataAgreement.vue?vue&type=template&id=1da7a796"
import script from "./ChatBotPersonalDataAgreement.vue?vue&type=script&lang=js"
export * from "./ChatBotPersonalDataAgreement.vue?vue&type=script&lang=js"
import style0 from "./ChatBotPersonalDataAgreement.vue?vue&type=style&index=0&id=1da7a796&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports